// @flow
import moment from "moment";
import { percentage } from "./Timers";

type DurationProps = {
  expireTime: moment$Moment,
  creationTime: moment$Moment,
  currentTime: moment$Moment
};

export const calcBonusDuration = ({
  expireTime,
  creationTime,
  currentTime
}: DurationProps) => {
  // рассчитываем процент для круглого прогресс-бара
  // чем меньше остается времени - тем больше кругляшок заполнен
  // берем за 100% duration от регистрации до expireTime в секундах
  const aHundredPercent = moment
    .duration(expireTime.diff(creationTime))
    .asSeconds();
  // считаем difference в секундах
  const fraction = moment.duration(expireTime.diff(currentTime)).asSeconds();
  const percent = percentage(fraction, aHundredPercent, { direction: "from" });

  return percent;
};

export type RegBonus = {
  status: "available" | "applied" | "refused" | "timeout", // таймер еще тикает | бонус применен | отказался от бонусов | время вышло
  creation_time: number, // время регистрации
  expire_time: number, // время протухания бонуса
  percent: 25 | 50, // процент бонуса на депозит
  promo: string // промокод, который подставится на клиенте
};

const Bonus: RegBonus = {
  status: "available",
  creation_time: moment("2019-01-29 16:01:37").unix(),
  expire_time: moment("2019-02-01 16:01:37").unix(),
  percent: 25,
  promo: "GHRK"
};

export default Bonus;



// WEBPACK FOOTER //
// ./src/components/DepositBonus.js